import script from "./ObstacleRace2026.vue?vue&type=script&setup=true&lang=js"
export * from "./ObstacleRace2026.vue?vue&type=script&setup=true&lang=js"

import "./ObstacleRace2026.vue?vue&type=style&index=0&id=14be8a3e&setup=true&lang=css"

const __exports__ = script;

export default __exports__